import "./input.css";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import NavBar from "./components/NavBar.jsx";

import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Portfolio from "./pages/Portfolio.jsx";
import Legal from "./pages/legal/Legal.jsx";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy.jsx";
import CustomerTerm from "./pages/legal/CustomerTerm.jsx";
import ServiceProviderTerm from "./pages/legal/ServiceProviderTerm.jsx";
import Footer from "./components/Footer.jsx";
import UsePremiumScreen from "./pages/UsePremium.jsx";

function App() {
  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  }

  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/premium" element={<UsePremiumScreen />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/legal/customer-term" element={<CustomerTerm />} />
        <Route path="/legal/service-provider-term" element={<ServiceProviderTerm />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;